import PropTypes from "prop-types";

import React from "react";

// import { withRouter, matchPath } from "react-router";

import Link from "../../Link";
// ^^ A Link element for our custom history router.

import SEO from "../../../../../global-components/seo";

import * as ROUTES from "../../../constants/routes.js";

import "./style.scss";

class UploadButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //
    };

    this.vars = {
      //
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    /* if (this.props.currentRoute !== prevProps.currentRoute) {
            Z.loadPage();
        } */
  }

  init = () => {
    const Z = this;

    Z.initFieldValue();
  };

  initFieldValue = () => {
    const Z = this;

    if (Z.props.updateFormValue != null) {
      Z.props.updateFormValue({
        fieldName: Z.props.name,
        fieldValue: null,
        fieldType: "UploadButton",
        fieldRequired: Z.props.required,
      });
    }
  };

  updateFieldValue = (event) => {
    const Z = this;

    let newFile = event.target.files[0];

    if (Z.props.updateFormValue != null) {
      Z.props.updateFormValue({
        fieldName: Z.props.name,
        fieldValue: newFile,
        fieldType: "UploadButton",
        fieldRequired: Z.props.required,
      });
    }
  };

  render() {
    var Z = this;

    var filename = (Z.props.formValues[Z.props.name] && Z.props.formValues[Z.props.name].name) ?? "";

    return (
      <div className={`UploadButton ${Z.props.formErrors[Z.props.name] != null && Z.props.formErrors[Z.props.name] != false ? "error" : ""}`}>
        <input type="file" name={Z.props.name} placeholder={Z.props.placeholder} onChange={Z.updateFieldValue} />
        <div className={`button-cover ${filename != "" ? "has-file" : ""}`}>
          <span className="button-title">{Z.props.placeholder}</span>
          <span className="filename-label">{filename}</span>
        </div>
      </div>
    );
  }
}

UploadButton.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  formValues: PropTypes.object,
  updateFormValue: PropTypes.func,
};

export default UploadButton;
